// extracted by css-extract-rspack-plugin
export default {"container":"InfiniteScroll_container__anwKh"};